import { SortColumn } from "@goodfill/sort";
import { SortColumn as GridSortColumn } from "react-data-grid";

export const mapSortColumnFromGrid = <T>(column: GridSortColumn): SortColumn<T> => ({
  columnKey: column.columnKey as T,
  direction: column.direction,
});
